import styled from 'styled-components'

import { Image as ImageBase } from '@application/Interfaces/Atoms/Image'

export const Image = styled(ImageBase)`
    max-width: 25px;

    svg {
        max-width: 25px;
    }

    @media ${(props) => props.theme.query.min.tablet} {
        max-width: 40px;

        svg {
            max-width: 40px;
        }
    }
`

export const TextWrapper = styled.div``

export const Title = styled.h3`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.g600};
    margin-bottom: 8px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayM};
    }
`

export const Description = styled.p`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.regular};
    color: ${(props) => props.theme.color.g500};
    text-align: justify;

    @media ${(props) => props.theme.query.min.tablet} {
        text-align: left;
    }
`
